export enum PageType {
    COVID_HEALTH_DECLARATION = 'COVID_HEALTH_DECLARATION',
    MESSAGES = 'MESSAGES',
    FINAL_PAGE = 'FINAL_PAGE'
}
